import { initializeApp } from 'firebase/app'
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check'
import { ref, child, getDatabase, push } from 'firebase/database'
import { createContext } from 'react'
import { storeUserId } from './storeToLocalStorage'
import { mod1271_36 } from 'cdigit'


const app = initializeApp({
  apiKey: "AIzaSyBGF-_kiDVID2D9_8A8i4zLtHWYxG704yA",
  authDomain: "wch-interactive.firebaseapp.com",
  databaseURL: "https://2023-quiz-monarchie-britannique.europe-west1.firebasedatabase.app/",
  projectId: "wch-interactive",
  storageBucket: "wch-interactive.appspot.com",
  messagingSenderId: "717470310087",
  appId: "1:717470310087:web:dc0f5716bd65c5fdee68e2",
  measurementId: "G-07NSJLDQRX"
})

// reCaptcha c3
const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider('6LdajlklAAAAAAw9NwFCks6J4pO1mQvDbJpxCAze'),
  isTokenAutoRefreshEnabled: true,
})

// Get a reference to the database service and provide it via context
const db = getDatabase(app)
const municipalityAveragesRef = ref(db, 'municipalityAverages')
const nationalAveragesRef = ref(db, 'nationalAverages')
const userAnswersRef = ref(db, 'userAnswers')
const dbRef = ref(db)
let uniqueId
try {
  uniqueId =
    localStorage.getItem('swissQuizUserId') ||
    mod1271_36.generate(
      push(child(ref(db), '/')).key ||
        Math.random().toString(36).substring(2, 15)
    )
} catch {
  console.log('cannot access local storage')
}

uniqueId && storeUserId(uniqueId)

export const firebaseContext = createContext({
  municipalityAveragesRef,
  nationalAveragesRef,
  userAnswersRef,
  dbRef,
  uniqueId,
})
